export default __webpack_public_path__ + "static/media/dolcemare1.0ad5716e.jpg";